import request from 'utils/request'

// MCBHS131初期化
export const getMCBHS131InitRequest = () => 
request({
  url: '/MCBHS131/init',
  method: 'post',
})

